import './RenderName.css';
import action from './eventListeners';
import layout from './RenderName';

export default {
  layout,
  action
};
